// extracted by mini-css-extract-plugin
module.exports = {"tabs":"HouseManager_tabs__3QJkb","comingSoon":"HouseManager_comingSoon__3AD7z"};